<script>
import uploadImg from '@/components/uploadImage/index.vue'
import videoUpload from '@/components/uploadVideo/index.vue'
import PositionSelection from '@/components/project/PositionSelection.vue'
import PositionShow from '@/components/project/PositionShow.vue'
import AddTaskStep from '@/components/project/AddTaskStep.vue'
import { autoCreatePosition, autoCreateTask } from '@/api/merchant/service/project'
import { getVeriOrderOption } from '@/api/demo/veriOrder'
import { certDetail } from '@/api/demo/close'
import selectFileList from '@/components/file/selectFileList.vue'
import { tagOptions } from '@/api/demo/task'
export default {
  name: 'AddTaskItem',
  components: { AddTaskStep, PositionShow, PositionSelection, uploadImg, selectFileList, videoUpload },
  props: {
    value: {
      type: Object,
      default: {
        tasks: []
      }
    },
    defaultDirId: {
      default: '0'
    }
  },
  data () {
    return {
      verificationOrderOption: [],
      newTabInx: 0,
      certInfo: {},
      tagList: [],
      editableTabsValue: '',
      item: {
        ...this.value
      },
      itemRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请上传封面', trigger: 'blur' }
        ],
        completionDays: [
          { required: true, message: '请输入完成周期', trigger: 'blur' }
        ],
        introduction: [
          { required: true, message: '请输入内容介绍', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    console.log('this.value --->>>', this.value)
    if (this.value && this.value.tasks && this.value.tasks.length > 0) {
      this.editableTabsValue = this.value.tasks[0].step + ''
    }
    console.log('created --->>>')
    this.getVerificationOrderOption()
    this.getPositionDetail()
    this.getTagList()
  },
  methods: {
    async getPositionDetail () {
      if (!this.value.certId) {
        return
      }
      certDetail(this.value.certId).then(res => {
        this.certInfo = res
      })
    },
    updateValue (val) {
      this.$emit('input', val)
    },

    addTab (targetName) {
      this.newTabInx++
      if (!this.item.tasks) {
        this.item.tasks = []
      }
      let tabs = this.item.tasks

      let newTabName = '新建步骤' + this.newTabInx + '[请修改]'
      let step = tabs.length === 0 ? 1 : tabs[tabs.length - 1].step + 1
      this.item.tasks.push({
        title: newTabName,
        step: step
      })
      console.log('tabs', this.item.tasks)
      this.editableTabsValue = step + ''
    },
    removeTab (targetName) {
      this.$confirm('确认删除步骤吗', '确认操作', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.confirmRemoveTab(targetName)
        })
        .catch(() => {
        })
    },
    confirmRemoveTab (targetName) {
      console.log('targetName', targetName)
      let tabs = this.item.tasks
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.step === parseInt(targetName)) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.step + ''
            }
          }
        })
      } else {
        this.$forceUpdate()
      }

      this.editableTabsValue = activeName
      this.item.tasks = tabs.filter(tab => tab.step !== parseInt(targetName))
    },

    updateItemValue (index, value) {
      console.log(index, value)
      this.$set(this.item.tasks, index, value)
    },
    autoCreateStep () {
      let loading = this.$loading({
        lock: true,
        text: '正在分析任务...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let that = this
      let error = false
      autoCreateTask(this.item.details).then(res => {
        that.item.tasks = res
        that.editableTabsValue = '1'
        console.log(that.item.tasks, 'res')
        this.updateValue(that.item)
        this.$forceUpdate()
        loading.close()
      }).catch(err => {
        loading.close()
        error = true
      })
      setTimeout(() => {
        loading.close()
        if (error) {
          return
        }
        loading = this.$loading({
          lock: true,
          text: '正在匹配案例...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }, 1000)
      setTimeout(() => {
        loading.close()
        if (error) {
          return
        }
        loading = this.$loading({
          lock: true,
          text: '正在生成步骤...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }, 2000)
    },
    getVerificationOrderOption () {
      console.log('getVerificationOrderOption --->>>')
      let that = this
      getVeriOrderOption().then(res => {
        that.verificationOrderOption = res
      })
    },
    getTagList () {
      let that = this
      tagOptions().then(res => {
        that.tagList = res
      })
    }
  },
  watch: {
    item: {
      handler: function (val, oldVal) {
        this.updateValue(val)
      },
      deep: true
    },
    value: {
      handler: function (val, oldVal) {
        console.log('value handler', val)
        this.item = val
        this.getPositionDetail()
      },
      deep: true
    }
  }
}
</script>
<template>
  <el-form label-width="100px" :model="item" :rules="itemRules" size="mini">
    <el-form-item label="岗位" prop="certId">
      <PositionSelection v-model="item.certId"></PositionSelection>
    </el-form-item>
    <el-form-item label="标题" prop="title">
      <el-input v-model="item.title" placeholder="输入标题(前端显示)" :clearable="true"></el-input>
    </el-form-item>
    <el-form-item label="是否公开" prop="isPublic">
      <el-radio-group v-model="item.isPublic">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="封面" prop="title">
      <upload-img label="封面" prop="icon" v-model="item.icon" :max="1">
      </upload-img>
    </el-form-item>

    <!-- 视频背景 -->
    <el-form-item label="视频背景" prop="infoBack">
      <video-upload label="视频背景" prop="infoBack" v-model="item.infoBack" :max="1"></video-upload>
    </el-form-item>

    <!--  标签，多选   -->
    <el-form-item label="标签" prop="tagList">
      <el-select v-model="item.tagIds" multiple placeholder="请选择">
        <el-option v-for="item in tagList" :key="item.key" :label="item.value" :value="item.key">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="薪酬" prop="reward">
      <el-input-number v-model="item.reward" :step="0.01" step-strictly></el-input-number> 元
    </el-form-item>

    <el-form-item label="人数" prop="numOfPeople">
      <el-input-number v-model="item.numOfPeople" :step="1" step-strictly></el-input-number> 人
    </el-form-item>

    <el-form-item label="交付时间" required prop="endTime">
      <el-date-picker v-model="item.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
        placeholder="选择日期时间"></el-date-picker>
    </el-form-item>
    <el-form-item label="任务介绍">
      <el-input type="textarea" placeholder="请输入内容" v-model="item.details" maxlength="1000" show-word-limit></el-input>
      <el-button @click="autoCreateStep" class="filter-item" type="primary" icon="add" size="small"
        style="margin-top:5px;">生成步骤</el-button>
    </el-form-item>
    <el-form-item label="任务步骤">
      <div style="margin-bottom: 20px;">
        <el-button size="small" @click="addTab()" type="primary">
          添加步骤
        </el-button>
      </div>
      <el-tabs v-model="editableTabsValue" tab-position="left" type="border-card" style="min-height: 400px" closable
        @tab-remove="removeTab">
        <el-tab-pane v-for="(task, index) in item.tasks" :key="task.step + ''"
          :label="'步骤' + task.step + ':' + task.title" :name="task.step + ''">
          <AddTaskStep :value="task" @input="value => updateItemValue(index, value)"></AddTaskStep>
        </el-tab-pane>
      </el-tabs>
    </el-form-item>
    <el-form-item v-if="certInfo.type === 1" label="销售单">
      <el-select v-model="item.verificationOrderId" filterable placeholder="请选择">
        <el-option reserve-keyword v-for="option in verificationOrderOption" :key="option.key" :label="option.value"
          :value="option.key">
        </el-option>
      </el-select>
      <el-link style="margin-left: 10px" @click="$router.push('/demo/veriOrder/edit')" type="primary">新建销售单</el-link>
    </el-form-item>
    <el-form-item label="任务素材">
      <select-file-list :value="item.resourceList" @update:value="item.resourceList = $event"
        :default-dir-id="defaultDirId"></select-file-list>
    </el-form-item>
  </el-form>
</template>

<style scoped></style>
